import React, { useEffect, useRef, useState } from "react";
import styled from "@emotion/styled";
import { useDispatch, useSelector } from "react-redux";
import {
  CustomerName,
  toggleEditModel,
  toggleChangePasswordModel,
} from "../Customer";
import { signOut } from "../Security";
import { isSignedInSelector } from "ccui-framework";

const Item = styled.a`
  cursor: pointer;
  font-family: Montserrat, serif;
  height: 25px;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: -0.2px;
  color: #777984;
  padding: 1rem;

  &:hover {
    text-decoration: none;
    color: #1f2021;
  }
`;

const Menu = styled.div`
  position: absolute;
  top: 4rem;
  width: 250px;
  background: #ffffff;
  box-shadow: 0px 0px 50px rgba(31, 32, 33, 0.08);
  right: 3rem;
  flex-direction: column;
  align-items: left;
  padding: 1rem 0 2rem 2rem;
  display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
  z-index: 50;
`;

const Icon = styled.span`
  margin-left: 0.5rem;
`;

const Right = styled.div`
  margin-top: 0.5rem;
  align-content: flex-end;
`;

const Logo = styled.img`
  height: 2rem;
`;

const Container = styled.div`
  display: flex;
  justify-content: ${({ isSignedIn }) =>
    !isSignedIn ? "center" : "space-between"};
  flex: 0 0 100%;
  align-items: center;
  background: #ffffff;
  box-shadow: 0 1px 0 #e1eaed;
  padding-right: ${({ isSignedIn }) => (!isSignedIn ? "0" : "5rem")};
  max-height: 65px;
  flex-shrink: 0;
  border-bottom: 1px solid #e1eaed;
`;

const Left = styled.div`
  ${({ isSignedIn }) =>
    isSignedIn
      ? `  
      display: flex;
      width: 250px;
      justify-content: flex-end;`
      : ""}
`;

const HeaderDropDownMenu = () => {
  const [isDropDownMenuOpen, setDropDownMenuOpen] = useState(false);
  const HeaderDropDownMenuRef = useRef(null);

  useEffect(() => {
    const listener = (event) => {
      if (
        !HeaderDropDownMenuRef.current ||
        HeaderDropDownMenuRef.current.contains(event.target)
      ) {
        return;
      }
      setDropDownMenuOpen((isDropDownMenuOpen) =>
        isDropDownMenuOpen ? !isDropDownMenuOpen : isDropDownMenuOpen
      );
    };
    document.addEventListener("mousedown", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
    };
  }, [HeaderDropDownMenuRef]);

  return [isDropDownMenuOpen, setDropDownMenuOpen, HeaderDropDownMenuRef];
};

const Header = () => {
  const dispatch = useDispatch();
  const isSignedIn = useSelector((state) => isSignedInSelector(state));
  const [isDropDownMenuOpen, setDropDownMenuOpen, HeaderDropDownMenuRef] =
    HeaderDropDownMenu();

  return (
    <Container id="header" isSignedIn={isSignedIn}>
      <Left isSignedIn={isSignedIn}>
        <Logo
          src="https://cdn.cardcash.com/website/premier/cardcash_premier.svg"
          alt="Premier Logo"
        />
      </Left>

      {isSignedIn && (
        <Right>
          <CustomerName>
            <Icon
              onClick={() =>
                setDropDownMenuOpen((isDropDownMenuOpen) => !isDropDownMenuOpen)
              }
            >
              <svg
                width="10"
                height="6"
                viewBox="0 0 10 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.183058 0.183058C0.400016 -0.0338997 0.736797 -0.0580061 0.980382 0.110739L1.06694 0.183058L4.625 3.742L8.18306 0.183058C8.40002 -0.0338997 8.7368 -0.0580061 8.98038 0.110739L9.06694 0.183058C9.2839 0.400016 9.30801 0.736797 9.13926 0.980382L9.06694 1.06694L5.06694 5.06694C4.84998 5.2839 4.5132 5.30801 4.26962 5.13926L4.18306 5.06694L0.183058 1.06694C-0.0610194 0.822864 -0.0610194 0.427136 0.183058 0.183058Z"
                  fill="#777984"
                />
              </svg>
            </Icon>
            <Menu isOpen={isDropDownMenuOpen} ref={HeaderDropDownMenuRef}>
              <Item
                onClick={() => {
                  dispatch(toggleChangePasswordModel());
                  setDropDownMenuOpen(
                    (isDropDownMenuOpen) => !isDropDownMenuOpen
                  );
                }}
              >
                Change password
              </Item>
              <Item
                onClick={() => {
                  dispatch(toggleEditModel());
                  setDropDownMenuOpen(
                    (isDropDownMenuOpen) => !isDropDownMenuOpen
                  );
                }}
              >
                Profile
              </Item>
              <Item
                onClick={() => {
                  dispatch(signOut());
                }}
              >
                Log out
              </Item>
            </Menu>
          </CustomerName>
        </Right>
      )}
    </Container>
  );
};

Header.propTypes = {};

export { Header };
